export default "__VITE_ASSET__D0Egz5cf__"